module.exports = __webpack_public_path__ + "img/tpc-41.78b68e0d.webp";